import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import { unregister } from './registerServiceWorker';
import { ConfigProvider } from './config/ConfigProvider';
import App from './App';

createRoot(document.getElementById('App')).render(
  <ConfigProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
);

unregister();
